module.exports = __webpack_public_path__ + "static/media/avatar.ce4c987b.png";